import { newDateFromUTC, newDateToUTC } from '@bc-library/common'
import { staffingPeriodFromUTC, staffingPeriodToUTC } from '../project/hooks';
import { afterReceiving as afterReceivingResource } from '../resource/hooks';

// DATA RECEIVED FOM API (FROM UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const afterReceiving = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
     return afterReceivingOne(object);
   })
  }
  else if(data.docs && data.count && Array.isArray(data.docs)){
    data.docs = data.docs.map((object:any) => {
      return afterReceivingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = afterReceivingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const afterReceivingOne = (object:any) => {
  if(typeof object == 'object'){
    return{
      ...object,
      _created:new Date(object._created),
      staffingPeriod: staffingPeriodFromUTC(object.staffingPeriod),
      firstDate: object.firstDate && newDateFromUTC(object.firstDate),
      lastDate: object.lastDate && newDateFromUTC(object.lastDate),
      // Populated resource (jobs, departure, recruitment dates): calendar days like everywhere else
      resource: object.resource && typeof object.resource === 'object' ? afterReceivingResource(object.resource) : object.resource,
      isEdited: object.isEdited ? {
        ...object.isEdited,
        requestDate: object.isEdited.requestDate && new Date(object.isEdited.requestDate),
        staffingPeriod: object.isEdited.staffingPeriod && staffingPeriodFromUTC(object.isEdited.staffingPeriod)
      } : object.isEdited,
    }
  }
  return object;
}

// OBJECT FIELDS




// DATA TO BE SENT TO API (TO UTC)

// GENERAL CASE : ARRAY OR SINGLE OBJECT
export const beforeSending = (data:any) => {
  if(data && Array.isArray(data)){
    data = data.map((object:any) => {
      return beforeSendingOne(object);
    })
  }
  else if(typeof data == 'object'){
    data = beforeSendingOne(data);
  }
  return data;
};

// SINGLE OBJECT
export const beforeSendingOne = (object:any) => {
  if(typeof object == 'object'){
    return {
      ...object,
      staffingPeriod: staffingPeriodToUTC(object.staffingPeriod)
    }
  }
  return object;
}

export const beforeSendingPeriod = (data:any) => {
  if(typeof data == 'object'){
    return {
      ...data,
      startDate: data.startDate && newDateToUTC(data.startDate),
      endDate: data.endDate && newDateToUTC(data.endDate),
    }
  }
  return data;
}

// OBJECT FIELDS




